export default __webpack_public_path__ + "static/media/icon-play.f05fdd07.svg";